/**
 * @fileoverview POST handler for the "/email/ip_warming/:app_group_id/schedule_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdScheduleSettingsCacheKeys } from "./constants";
import type {
  PostEmailIpWarmingAppGroupIdScheduleSettingsProps,
  EmailIpWarmingAppGroupIdScheduleSettingsResult,
} from "./types";

export const postEmailIpWarmingAppGroupIdScheduleSettings = reactQueryMutationAdapter(
  emailIpWarmingAppGroupIdScheduleSettingsCacheKeys,
  (
    props: PostEmailIpWarmingAppGroupIdScheduleSettingsProps
  ): Promise<EmailIpWarmingAppGroupIdScheduleSettingsResult> => {
    // Extract appGroupId from props and prepare the request body
    const { appGroupId, ...requestBody } = props;

    return fetch(`/email/ip_warming/${appGroupId}/schedule_settings`, "POST", requestBody, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
